import { getYouTubeVideoId } from "@aichat/aichat-lib";

const YoutubePreview = ({ url }: { url: string }) => {
  const videoId = getYouTubeVideoId(url);

  if (!videoId) return <p>Invalid YouTube URL</p>;

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  return (
    <iframe
      src={`${embedUrl}?enablejsapi=1`}
      title="YouTube video preview"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className="w-full object-cover rounded-xl aichat-youtube-preview"
    ></iframe>
  );
};

export default YoutubePreview;
